import api from './api';
import types from './mutation-types';

export default {
	/**commit mutations*/
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setSelectedRow_({ commit }, { key, value }) {
		commit(types.SELECTED_ROW, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	/**call API */
	async getPlants_({ commit }) {
		try {
			const data = await api.getPlants();
			if (data.header.code === 0) {
				commit(types.DEFAULT_ASSIGN, { key: 'plants', value: data?.body });
				commit(types.SEARCH_PARAM, { key: 'plantCd', value: data?.body[0]?.commCd || '' });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getCommCodes_({ commit, state, rootGetters }, { key, codeType }) {
		try {
			await commit(types.SEARCH_PARAM, { key: 'codeType', value: codeType });
			const data = await api.getCommCodes(state.searchParams);
			if (data.header.code === 0) {
				let value = data.body?.map(item => {
					item.commCdName = rootGetters['commonStore/getMessage_'](item.commCdDesc);
					return item;
				});
				await commit(types.DEFAULT_ASSIGN, { key, value });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async getGroups_({ commit, state }) {
		try {
			const { searchParams, pagingInfo } = state;
			const data = await api.getGroups({ searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit });
			if (data.header.code === 0) {
				const { pagingInfo, resultList } = data.body;
				commit(types.DEFAULT_ASSIGN, { key: 'pagingInfo', value: pagingInfo });
				commit(types.DEFAULT_ASSIGN, { key: 'resultList', value: resultList });
				commit(types.DEFAULT_ASSIGN, { key: 'selectedRow', value: resultList[0] });
			} else if (data.header.code === 3) {
			}
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	},
	async setGroups_({ commit }, param) {
		try {
			const data = await api.postGroups(param);
			return data.header;
		} catch (error) {
			return error.header || error;
		}
	}
};
